export default (inputString, map) => {
	let str;
	if (typeof inputString === 'string') {
		str = inputString
			.toLowerCase()
			.split(' ')
			.map((word) => map[word] || word)
			.join(' ');
	}
	return str;
};
